<template>
  <div class="hospital-page">
    <!-- 预约须知区域 -->
    <div class="notice-section">
      <div class="notice-box">
        <img src="./assets/top.png" />
      </div>
    </div>

    <!-- 标签页 -->
    <div class="tabs-section">
      <div class="tab-item" :class="{ active: activeTab === 0 }" @click="activeTab = 0">
        体检医院
      </div>
      <div class="tab-item" :class="{ active: activeTab === 1 }" @click="activeTab = 1">
        体检地点
      </div>
      <div class="tab-item" :class="{ active: activeTab === 2 }" @click="activeTab = 2">
        结果查询
      </div>
    </div>

    <!-- 体检医院列表 -->
    <div v-if="activeTab === 0" class="hospital-list">
      <div v-for="(item, index) in hospitalList" :key="index" class="hospital-item-wrapper">
        <div class="hospital-item">
          <div class="logo-box" @click="toggleExpand(index)">
            <img :src="item.coverFile" class="hospital-img" />
          </div>
          <div class="hospital-info" @click="toggleExpand(index)">
            <div class="hospital-name">{{ item.name }}</div>
            <van-icon :name="item.expanded ? 'arrow-up' : 'arrow-down'" class="arrow-icon" />
          </div>
          <div v-if="item.id === 3 && isWeixin" class="wx-open-wrapper">
            <div v-show="isBookingEnabled" class="wx-open-container">
              预约
              <wx-open-launch-weapp
                id="launch-btn"
                username="gh_b02f6621db79"
                :path="`/pages/index/index`"
                style="position:absolute;top:0;left:0;right:0;bottom:0;width: 100%;height: 100%;color:#ffffff;"
              >
                <script type="text/wxtag-template">
                  <div style="position:absolute;left:0;top:0;width: 100%;height: 100%;color:#ffffff;"></div>
                </script>
              </wx-open-launch-weapp>
            </div>
            <div v-show="!isBookingEnabled" class="action-btn disabled">预约</div>
          </div>
          <div
            v-else
            :class="['action-btn', { disabled: !isBookingEnabled }]"
            @click="isBookingEnabled && handleBook(item)"
          >
            预约
          </div>
        </div>
        <!-- 展开的详情内容 -->
        <div v-show="item.expanded" class="hospital-detail">
          <div class="detail-content">
            <div v-if="index == 0" class="time-row">
              <p>1、请使用身份证或手机号（HR系统预留号码）进行登录；</p>
              <p>2、预约时间：周一至周六7:30-10:30（法定节假日除外），咨询电话：027-67813575。</p>
              <p>
                3、无痛肠胃镜套餐，需提前一天到体检中心开单子、做清肠；麻醉时需家属陪同；详情请咨询人力资源部。
              </p>
            </div>
            <div v-if="index == 1" class="time-row">
              <p>1、身份验证：身份证号；手机号为HR系统预留号码；</p>
              <p>2、预约时间：周一至周五7:30-11:30（法定节假日除外），咨询电话：027-87231011。</p>
            </div>
            <div v-if="index == 2" class="time-row">
              <p>1、团体预约，手机号为HR系统预留号码；</p>
              <p>2、预约时间：周一至周五7:30-11:30（法定节假日除外），咨询电话：027-85332429。</p>
            </div>
            <div v-if="index == 3" class="time-section">
              <p>1、请使用身份证或手机号（HR系统预留号码）进行登录；</p>
              <div class="time-label">2、预约时间：</div>
              <div class="time-content">
                <p>主院区本部：周一至周五7:30-10:30（法定节假日除外），咨询电话：027-85726513；</p>
                <p>金银湖院区：周一至周五8:00-10:30（法定节假日除外），咨询电话：027-83261380。</p>
              </div>
            </div>
            <div v-if="index == 4" class="time-section">
              <p>1、账号：身份证，密码：身份证后六位，如果最后为X，则为去掉X后的六位数字；</p>
              <div class="time-label">2、预约时间：</div>
              <div class="time-content">
                <p>
                  省人民医院（主院区、东院区、洪山院区）：周一至周五8:00-10:30（法定节假日除外）；
                </p>
                <p>爱康汉街分院：周一至周六7:30-10:30（法定节假日除外）；</p>
                <p>
                  爱康（亚贸分院、金墩分院、同学广场分院）：周二至周日上午7:30-10:30（法定节假日除外）；
                </p>
                <!-- <p>爱康亚贸分院：周二至周日7:30-10:30（法定节假日除外）；</p>
                <p>爱康金墩分院：周二至周日7:30-10:30（法定节假日除外）；</p>
                <p>爱康同学广场分院：周二至周日上午7:30-10:30（法定节假日除外）；</p> -->
              </div>
              <p>3、统一咨询电话和省外预约电话：18694059866。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 体检地点列表 -->
    <div v-if="activeTab === 1" class="location-list">
      <div v-for="(item, index) in locationList" :key="index" class="location-item">
        <div class="location-left">
          <div class="location-icon">
            <van-icon name="location-o" />
          </div>
          <div class="location-info">
            <div class="hospital-name">{{ item.name }}</div>
            <div class="address">地址：{{ item.address }}</div>
            <div class="route">乘车路线：{{ item.route }}</div>
            <div v-if="item.phone" class="route">咨询电话：{{ item.phone }}</div>
          </div>
        </div>
        <div class="copy-icon" @click="copyInfo(item)">
          <van-icon name="notes-o" />
        </div>
      </div>
    </div>

    <!-- 结果查询列表 -->
    <div v-if="activeTab === 2" class="result-list">
      <div v-for="(item, index) in resultList" :key="index" class="result-item">
        <div class="logo-box">
          <img :src="item.coverFile" class="hospital-img" />
        </div>
        <div class="hospital-info">
          <div class="hospital-name">{{ item.name }}</div>
        </div>
        <div v-if="item.id === 2 && isWeixin" class="wx-open-wrapper">
          <div v-show="isBookingEnabled" class="wx-open-container">
            查询
            <wx-open-launch-weapp
              id="launch-btn"
              username="gh_95514e58fc88"
              :path="`/pages/index/index`"
              style="position:absolute;top:0;left:0;right:0;bottom:0;width: 100%;height: 100%;color:#ffffff;"
            >
              <script type="text/wxtag-template">
                <div style="position:absolute;left:0;top:0;width: 100%;height: 100%;color:#ffffff;"></div>
              </script>
            </wx-open-launch-weapp>
          </div>
          <div v-show="!isBookingEnabled" class="action-btn disabled">查询</div>
        </div>
        <div v-else-if="item.id === 3 && isWeixin" class="wx-open-wrapper">
          <div v-show="isBookingEnabled" class="wx-open-container">
            查询
            <wx-open-launch-weapp
              id="launch-btn"
              username="gh_b02f6621db79"
              :path="`/pages/index/index`"
              style="position:absolute;top:0;left:0;right:0;bottom:0;width: 100%;height: 100%;color:#ffffff;"
            >
              <script type="text/wxtag-template">
                <div style="position:absolute;left:0;top:0;width: 100%;height: 100%;color:#ffffff;"></div>
              </script>
            </wx-open-launch-weapp>
          </div>
          <div v-show="!isBookingEnabled" class="action-btn disabled">查询</div>
        </div>
        <div
          v-else
          :class="['query-btn', { disabled: !isBookingEnabled }]"
          @click="isBookingEnabled && handleCheck(item)"
        >
          查询
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { jssdkSign } from '@/api/login'
import to from 'await-to'
export default {
  name: 'Hospital',
  data() {
    return {
      activeTab: 0,
      isWeixin: false,
      isBookingEnabled: false,
      hospitalList: [
        { name: '武汉大学中南医院', id: 1, expanded: false, coverFile:require('./assets/1.png'), },
        { name: '湖北省直属机关医院', id: 2, expanded: false, coverFile:require('./assets/2.png'), },
        { name: '武汉市第一医院', id: 3, expanded: false, coverFile:require('./assets/3.png'), },
        { name: '武汉协和医院', id: 5, expanded: false, coverFile:require('./assets/4.jpg'), },
        { name: '湖北省人民医院、爱康', id: 6, expanded: false, coverFile:require('./assets/5.png'), },
      ],
      locationList: [
        {
          name: '武汉大学中南医院',
          address: '武汉市武昌区东湖路169号3号楼2-3楼体检中心',
          route: '民主路小东门站乘14路公交中南医院站下车。',
        },
        {
          name: '湖北省直属机关医院',
          address: '湖北省武汉市武昌区水果湖东二路7号医院1-2楼体检中心',
          route:
            '中山路小东门乘坐公交K606路/606路/572路到东一路洪山路口站下车步行500米，地铁8号线洪山路站C出口步行100米。',
        },
        {
          name: '武汉市第一医院',
          address: '湖北省武汉市硚口区中山大道215号体检中心',
          route: '地铁6号线汉正街站D出口。',
        },
        {
          name: "湖北省人民医院主院区",
          address: "武昌区解放路238号主院区楚康楼体检中心",
          route: "地铁7号线或2号线转地铁4号线复兴路站。",
          phone: '13308621842',
        },
        {
          name: "湖北省人民医院东院区",
          address: "湖北省武汉市东湖高新开发区高新六路佛祖岭社区B区对面",
          route: "地铁2号线佛祖岭B出口。",
          phone: '88041911转83716',
        },
        {
          name: "湖北省人民医院洪山院区",
          address: "湖北省武汉市洪山区白沙四路与光霞路交叉路口",
          route: "地铁5号线光霞站转632路、636到院区南门。",
          phone: '88041911转85302',
        },
        {
          name: '武汉协和医院主院区本部',
          address: '武汉市解放大道1277号健康管理中心（综合2号楼）',
          route: '地铁2号线中山公园站C出口。',
          phone: '027-85726513',
        },
        {
          name: '武汉协和医院金银湖院区',
          address: '武汉市东西湖区环湖路53号门诊3楼C区',
          route: '地铁7号线马池站C出口转356路公交到环湖路协和金银湖院区站。',
          phone: '027-83261380',
        },
        {
          name: '武汉爱康卓悦汉街分院',
          address: '武昌区中北路楚河汉街总部国际B座2-3层',
          route: '地铁4号线楚河汉街站（B出口）下车步行500米。',
        },
        {
          name: '武汉爱康卓悦亚贸分院',
          address: '武昌区武珞路丁字桥南方帝园A座1-3层',
          route: '地铁2号线宝通寺站（A出口）下车步行500米。',
        },
        {
          name: '武汉爱康国宾金墩分院',
          address: '江汉区后襄河北路59号海马中心1幢3层',
          route: '地铁2号线汉口火车站（F出口）下车步行700米。',
        },
        {
          name: '武汉爱康国宾同学广场分院',
          address: '民族大道同学广场2楼',
          route: '中山路小东门乘572路、811路公交车民族大道中南民族大学站下车。',
        },
      ],
      resultList: [
        { name: '武汉大学中南医院', id: 1, expanded: false, coverFile:require('./assets/1.png'), },
        { name: '湖北省直属机关医院', id: 2, expanded: false, coverFile:require('./assets/2.png'), },
        { name: '武汉市第一医院', id: 3, expanded: false, coverFile:require('./assets/3.png'), },
        { name: '武汉协和医院', id: 5, expanded: false, coverFile:require('./assets/4.jpg'), },
        { name: '湖北省人民医院', id: 6, expanded: false, coverFile:require('./assets/5.png'), },
        { name: '爱康体检中心', id: 7, expanded: false, coverFile:require('./assets/6.png'), },
      ],
    }
  },
  mounted() {
    this.checkBookingDate()
    this.initWeixinConfig()
    // 监听 pageshow 事件，处理安卓微信返回时刷新页面
    window.addEventListener('pageshow', this.handlePageShow)
    // 监听 visibilitychange 事件，处理页面从隐藏变为显示时刷新（滑动到页面）
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },
  beforeDestroy() {
    window.removeEventListener('pageshow', this.handlePageShow)
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },
  methods: {
    handlePageShow(event) {
      console.log('pageshow 事件触发', event.persisted)
      // event.persisted 为 true 表示页面从缓存中恢复（返回操作）
      if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
        console.log('从缓存恢复，强制刷新页面')
        window.location.reload()
        // this.checkBookingDate()
        // this.initWeixinConfig()
      }
    },
    handleVisibilityChange() {
      // 页面从隐藏状态变为显示时刷新（滑动到页面）
      if (document.visibilityState === 'visible') {
        console.log('页面变为可见，强制刷新页面')
        window.location.reload()
        // this.checkBookingDate()
        // this.initWeixinConfig()
      }
    },
    async initWeixinConfig() {
      this.docReady(async () => {
        var ua = navigator.userAgent.toLowerCase()
        var isWXWork = ua.match(/wxwork/i) == 'wxwork'
        var isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger'
        this.isWeixin = isWeixin
        // this.isWeixin = /MicroMessenger/i.test(navigator.userAgent)
        if (this.isWeixin) {
          // 微信签名 URL 不能包含 hash
          const signUrl = window.location.href.split('#')[0]
          console.log(`output->signUrl`, signUrl)
          const [res, err] = await to(
            jssdkSign({
              businessId: 110000,
              snsType: 'WEIXIN_MINI_APP',
              url: signUrl,
            }),
          )
          if (err) {
            console.error('jssdkSign 接口调用失败:', err)
            return
          }
          console.log(`output->res`, res)
          if (!res || !res.data) {
            console.error('jssdkSign 返回数据为空')
            return
          }
          wx.config({
            debug: false, // 关闭调试模式
            appId: res.data.appId,
            timestamp: res.data.timestamp,
            nonceStr: res.data.nonceStr,
            signature: res.data.signature,
            jsApiList: ['miniProgram.navigateTo', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline'],
            openTagList: ['wx-open-launch-weapp'],
          })
          wx.error(function(res) {
            console.error('wx.config 失败:', res)
            // 可以在这里添加提示
          })
          wx.ready(() => {
            console.log('wx.config 成功，开始配置分享')
            // 分享给朋友
            wx.updateAppMessageShareData({
              title: '集团公司总部体检管理',
              desc: '请提前三天预约，截止日期：2026年12月10日！',
              link: window.location.href,
              imgUrl: 'https://pro-file-1303899422.cos.ap-guangzhou.myqcloud.com/file/20260420/%E4%B8%AD%E9%93%81%E4%BD%93%E6%A3%80%E5%B0%81%E9%9D%A2.png',
              success: function() {
                console.log('分享给朋友成功')
              },
              cancel: function() {
                console.log('用户取消分享')
              }
            })
            // 分享到朋友圈（朋友圈不显示desc，所以title需要包含关键信息）
            wx.updateTimelineShareData({
              title: '集团公司总部体检管理 - 请提前三天预约，截止2026年12月10日',
              link: window.location.href,
              imgUrl: 'https://pro-file-1303899422.cos.ap-guangzhou.myqcloud.com/file/20260420/%E4%B8%AD%E9%93%81%E4%BD%93%E6%A3%80%E5%B0%81%E9%9D%A2.png',
              success: function() {
                console.log('分享到朋友圈成功')
              },
              cancel: function() {
                console.log('用户取消分享')
              }
            })
            // 兼容旧版微信客户端
            wx.onMenuShareAppMessage({
              title: '集团公司总部体检管理',
              desc: '请提前三天预约，截止日期：2026年12月10日！',
              link: window.location.href,
              imgUrl: 'https://pro-file-1303899422.cos.ap-guangzhou.myqcloud.com/file/20260420/%E4%B8%AD%E9%93%81%E4%BD%93%E6%A3%80%E5%B0%81%E9%9D%A2.png',
              success: function() {
                console.log('分享给朋友成功(旧版)')
              }
            })
            wx.onMenuShareTimeline({
              title: '集团公司总部体检管理 - 请提前三天预约，截止2026年12月10日',
              link: window.location.href,
              imgUrl: 'https://pro-file-1303899422.cos.ap-guangzhou.myqcloud.com/file/20260420/%E4%B8%AD%E9%93%81%E4%BD%93%E6%A3%80%E5%B0%81%E9%9D%A2.png',
              success: function() {
                console.log('分享到朋友圈成功(旧版)')
              }
            })
          })
        }
      })
    },
    handleWxTagError(e) {
      console.error('微信开放标签加载失败:', e)
      // 如果加载失败，尝试重新初始化
      this.delayedInitWeixin()
    },
    handleWxTagLaunch(e) {
      console.log('微信开放标签点击成功:', e)
    },
    docReady(fn) {
      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        fn()
      } else {
        document.addEventListener('DOMContentLoaded', fn)
      }
    },
    checkBookingDate() {
      const now = new Date()
      const startDate = new Date('2026-04-24')
      const endDate = new Date('2026-12-10')
      endDate.setHours(23, 59, 59, 999)
      this.isBookingEnabled = now >= startDate && now <= endDate
    },
    toggleExpand(index) {
      const isExpanding = !this.hospitalList[index].expanded
      this.hospitalList.forEach((item, i) => {
        item.expanded = i === index && isExpanding
      })
    },
    handleBook(item) {
      if (item.id === 1) {
        window.location.href = 'https://www.mytijian.com/m/whznyyqd/card/receivecard?openId=saved'
      } else if (item.id === 2) {
        window.location.href = 'https://portal.huashihy.com/hshbszyy/examCard/index?cdk=xxxxx'
      } else if (item.id === 3) {
        const miniProgramLink = '#小程序://武汉市第一医院健康体检/mO4Umpihuvn0WOw'
        this.copyToClipboard(miniProgramLink)
        this.$toast.success('小程序链接已复制，请粘贴到微信聊天框打开')
      } else if (item.id === 5) {
        window.location.href =
          'https://www.mytijian.com/m/whxhjkglzx/card/receivecard?newCompanyId=&loginName=&openId=saved'
      } else if (item.id === 6) {
        window.location.href = 'https://ee.ikang.com/employee/platform/ztsyj/newIndex'
      }
    },
    handleCheck(item) {
      if (item.id === 1) {
        window.location.href = 'https://www.mytijian.com/m/whznyyqd/card/receivecard?openId=saved'
      } else if (item.id === 2) {
        const miniProgramLink = '#小程序://湖北省直属机关医院健康医学中心/pBql0tZB8hgLRxC'
        this.copyToClipboard(miniProgramLink)
        this.$toast.success('小程序链接已复制，请粘贴到微信聊天框打开')
      } else if (item.id === 3) {
        const miniProgramLink = '#小程序://武汉市第一医院健康体检/mO4Umpihuvn0WOw'
        this.copyToClipboard(miniProgramLink)
        this.$toast.success('小程序链接已复制，请粘贴到微信聊天框打开')
      } else if (item.id === 5) {
        window.location.href =
          'https://www.mytijian.com/m/whxhjkglzx/card/receivecard?newCompanyId=&loginName=&openId=saved'
      } else if (item.id === 6) {
        window.location.href = 'https://tj.whdxrmyy.cn/mobileHealth/report/searchReport-h5-1.html'
      } else if (item.id === 7) {
        window.location.href = 'https://ee.ikang.com/employee/platform/ztsyj/newIndex'
      }
    },
    copyToClipboard(text) {
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
    },
    copyInfo(item) {
      const text = `${item.name}\n地址：${item.address}\n乘车路线：${item.route}`
      this.copyToClipboard(text)
      this.$toast.success('信息已复制')
    },
  },
}
</script>

<style scoped lang="scss">
.hospital-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

// 顶部导航栏
.header {
  background: linear-gradient(135deg, #e8e8e8 0%, #f0f0f0 100%);
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 1.2rem;
    padding: 0 0.4rem;

    .back-btn {
      width: 0.8rem;
      height: 0.8rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.58rem;
      color: #333;
    }

    .title {
      width: 100%;
      font-size: 0.56rem;
      font-weight: 500;
      color: #333;
      text-align: center;
    }

    .placeholder {
      width: 0.8rem;
    }
  }
}

// 预约须知区域
.notice-section {
  // padding: 0.4rem;
  background: linear-gradient(135deg, #e8e8e8 0%, #f0f0f0 100%);

  .notice-box {
    width: 100%;
    height: 4rem;
    background: linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%);
    border-radius: 0.16rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0.2rem;
      left: 0.2rem;
      right: 0.2rem;
      bottom: 0.2rem;
      // border: 1px solid #91d5ff;
    }
    img{
      width: 100%;
      height: 100%;
    }
    .notice-content {
      text-align: center;

      .notice-title {
        font-size: 0.52rem;
        font-weight: 600;
        color: #1890ff;
        margin-bottom: 0.2rem;
      }

      .notice-subtitle {
        font-size: 0.44rem;
        color: #1890ff;
        margin-bottom: 0.1rem;
      }

      .notice-deadline {
        font-size: 0.42rem;
        color: #1890ff;
      }
    }
  }
}

// 标签页
.tabs-section {
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;

  .tab-item {
    flex: 1;
    text-align: center;
    padding: 0.4rem 0;
    font-size: 0.46rem;
    color: #666;
    position: relative;
    cursor: pointer;

    &.active {
      color: #1890ff;
      font-weight: 500;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 0.8rem;
        height: 0.06rem;
        background-color: #1890ff;
        border-radius: 0.03rem;
      }
    }
  }
}

// 医院列表
.hospital-list {
  padding: 0.3rem;

  .hospital-item-wrapper {
    background-color: #fff;
    border-radius: 0.16rem;
    margin-bottom: 0.3rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    overflow: hidden;
  }

  .hospital-item {
    display: flex;
    align-items: center;
    padding: 0.3rem;

    .logo-box {
      width: 1.2rem;
      height: 1.2rem;
      border: 1px solid #e5e5e5;
      border-radius: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      cursor: pointer;
      background-color: #fff;

      .hospital-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 0.08rem;
      }
    }

    .hospital-info {
      flex: 1;
      margin-left: 0.3rem;
      display: flex;
      align-items: center;
      cursor: pointer;

      .hospital-name {
        font-size: 0.46rem;
        color: #333;
        line-height: 1.4;
      }

      .arrow-icon {
        margin-left: 0.2rem;
        font-size: 0.4rem;
        color: #1890ff;
      }
    }

    .wx-open-wrapper {
      position: relative;
      display: inline-block;
      min-width: 1.5rem;
      height: 0.8rem;
    }

    .wx-open-container {
      position: relative;
      // display: inline-block;
      padding: 0.2rem 0.5rem;
      background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
      color: #fff;
      font-size: 0.44rem;
      border-radius: 0.4rem;
      flex-shrink: 0;
    }

    .wx-open-backup {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .action-btn {
      padding: 0.2rem 0.5rem;
      background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
      color: #fff;
      font-size: 0.44rem;
      border-radius: 0.4rem;
      cursor: pointer;
      flex-shrink: 0;

      &.disabled {
        background: #ccc;
        cursor: not-allowed;
      }
    }
  }

  // 展开的详情内容
  .hospital-detail {
    padding: 0 0.3rem 0.3rem 0.3rem;

    .detail-content {
      background-color: #e6f7ff;
      border: 1px solid #91d5ff;
      border-radius: 0.12rem;
      padding: 0.3rem;

      p {
        font-size: 0.42rem;
        color: #1890ff;
        line-height: 1.6;
        margin: 0;
        text-align: justify;
        word-break: normal;

        & + p {
          margin-top: 0.1rem;
        }
      }

      .time-row {
        font-size: 0.42rem;
        color: #1890ff;
        line-height: 1.6;
        margin-top: 0.1rem;
      }

      .time-section {
        font-size: 0.42rem;
        color: #1890ff;
        line-height: 1.6;
        margin-top: 0.1rem;
        text-align: justify;

        .time-label {
          flex-shrink: 0;
        }

        .time-content {
          width: 100%;

          p {
            margin: 0;
            text-align: justify;

            & + p {
              margin-top: 0.1rem;
            }
          }
        }
      }
    }
  }
}

// 体检地点列表
.location-list {
  padding: 0.3rem;

  .location-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #fff;
    border-radius: 0.16rem;
    padding: 0.4rem;
    margin-bottom: 0.3rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .location-left {
      display: flex;
      flex: 1;

      .location-icon {
        width: 0.6rem;
        height: 0.6rem;
        margin-right: 0.2rem;
        margin-top: 0.05rem;

        .van-icon {
          font-size: 0.58rem;
          color: #1890ff;
        }
      }

      .location-info {
        flex: 1;

        .hospital-name {
          font-size: 0.48rem;
          color: #333;
          font-weight: 500;
          margin-bottom: 0.2rem;
        }

        .address {
          font-size: 0.42rem;
          color: #666;
          line-height: 1.5;
          margin-bottom: 0.1rem;
        }

        .route {
          font-size: 0.42rem;
          color: #666;
          line-height: 1.5;
        }
      }
    }

    .copy-icon {
      width: 0.8rem;
      height: 0.8rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin-left: 0.2rem;

      .van-icon {
        font-size: 0.58rem;
        color: #999;
      }
    }
  }
}

// 结果查询列表
.result-list {
  padding: 0.3rem;

  .result-item {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 0.16rem;
    padding: 0.3rem;
    margin-bottom: 0.3rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .logo-box {
      width: 1.2rem;
      height: 1.2rem;
      border: 1px solid #e5e5e5;
      border-radius: 0.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      cursor: pointer;
      background-color: #fff;

      .hospital-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 0.08rem;
      }
    }

    .hospital-info {
      flex: 1;
      margin-left: 0.3rem;

      .hospital-name {
        font-size: 0.46rem;
        color: #333;
        line-height: 1.4;
      }
    }
    .wx-open-wrapper {
      position: relative;
      display: inline-block;
      min-width: 1.5rem;
      height: 0.8rem;
    }
    .wx-open-container {
      position: relative;
      // display: inline-block;
      padding: 0.2rem 0.5rem;
      background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
      color: #fff;
      font-size: 0.44rem;
      border-radius: 0.4rem;
      flex-shrink: 0;
    }
    .query-btn {
      padding: 0.2rem 0.5rem;
      background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
      color: #fff;
      font-size: 0.44rem;
      border-radius: 0.4rem;
      cursor: pointer;
      flex-shrink: 0;

      &.disabled {
        background: #ccc;
        cursor: not-allowed;
      }
    }
  }
}

// 结果查询空状态
.result-section {
  padding: 2rem 0.3rem;

  .result-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .empty-icon {
      font-size: 2.08rem;
      color: #ccc;
      margin-bottom: 0.4rem;
    }

    .empty-text {
      font-size: 0.48rem;
      color: #999;
    }
  }
}
</style>
